var map = {
	"./de.js": [
		"./src/core/config/i18n/de.js"
	],
	"./en.js": [
		"./src/core/config/i18n/en.js"
	],
	"./sr.js": [
		"./src/core/config/i18n/sr.js"
	],
	"./sv.js": [
		"./src/core/config/i18n/sv.js",
		"lang-sv-js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/core/config/i18n lazy recursive ^\\.\\/.*\\.js$";
module.exports = webpackAsyncContext;